"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrollmentTransaction = void 0;
const consts_1 = require("../../consts");
const consts_2 = require("../../consts");
const core_1 = require("../../wallet/core");
const BaseTransaction_1 = require("./BaseTransaction");
const TransactionType_1 = __importDefault(require("./TransactionType"));
class EnrollmentTransaction extends BaseTransaction_1.BaseTransaction {
    constructor(obj = {}) {
        super(Object.assign({ version: consts_1.TX_VERSION.ENROLLMENT }, obj));
        this.type = TransactionType_1.default.EnrollmentTransaction;
        this.publicKey = obj.publicKey || "";
    }
    static deserializeExclusive(ss, tx) {
        const hexStrPrefix = ss.read(1);
        const prefix = parseInt(hexStrPrefix, 16);
        let pKey = "";
        // Compressed public keys.
        if (prefix === 0x02 || prefix === 0x03) {
            pKey = ss.read(32);
        }
        else if (prefix === 0x04) {
            pKey = ss.read(64);
        }
        else if (prefix === 0x00) {
            // infinity case.
            return Object.assign(tx, { publicKey: "" });
        }
        else {
            throw new Error("Prefix not recognised for public key");
        }
        pKey = hexStrPrefix + pKey;
        const publicKey = core_1.getPublicKeyUnencoded(pKey);
        return Object.assign(tx, { publicKey });
    }
    get exclusiveData() {
        return { publicKey: this.publicKey };
    }
    get fees() {
        return consts_2.DEFAULT_SYSFEE.enrollmentTransaction;
    }
    serializeExclusive() {
        if (this.publicKey === "") {
            return "00";
        }
        return core_1.getPublicKeyEncoded(this.publicKey);
    }
    export() {
        return Object.assign(super.export(), {
            publicKey: this.publicKey,
        });
    }
    equals(other) {
        if (this.type !== other.type) {
            return false;
        }
        if (other instanceof EnrollmentTransaction) {
            return this.hash === other.hash;
        }
        return this.hash === new EnrollmentTransaction(other).hash;
    }
}
exports.EnrollmentTransaction = EnrollmentTransaction;
exports.default = EnrollmentTransaction;
